var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkOutlineConnectionPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 24H43",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H20C19.4696 4 18.9609 4.21071 18.5858 4.58579C18.2107 4.96086 18 5.46957 18 6V14C18 14.5304 18.2107 15.0391 18.5858 15.4142C18.9609 15.7893 19.4696 16 20 16H28C28.5304 16 29.0391 15.7893 29.4142 15.4142C29.7893 15.0391 30 14.5304 30 14V6C30 5.46957 29.7893 4.96086 29.4142 4.58579C29.0391 4.21071 28.5304 4 28 4ZM16 32H8C7.46957 32 6.96086 32.2107 6.58579 32.5858C6.21071 32.9609 6 33.4696 6 34V42C6 42.5304 6.21071 43.0391 6.58579 43.4142C6.96086 43.7893 7.46957 44 8 44H16C16.5304 44 17.0391 43.7893 17.4142 43.4142C17.7893 43.0391 18 42.5304 18 42V34C18 33.4696 17.7893 32.9609 17.4142 32.5858C17.0391 32.2107 16.5304 32 16 32ZM40 32H32C31.4696 32 30.9609 32.2107 30.5858 32.5858C30.2107 32.9609 30 33.4696 30 34V42C30 42.5304 30.2107 43.0391 30.5858 43.4142C30.9609 43.7893 31.4696 44 32 44H40C40.5304 44 41.0391 43.7893 41.4142 43.4142C41.7893 43.0391 42 42.5304 42 42V34C42 33.4696 41.7893 32.9609 41.4142 32.5858C41.0391 32.2107 40.5304 32 40 32Z",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24V16M36 32V24M12 32V24",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineConnectionPoint);
export default __webpack_public_path__ + "static/media/icon-park-outline_connection-point.ad4069d9.svg";
export { ForwardRef as ReactComponent };